const getUserAgent = (userAgent?: string): string => {
  if (userAgent) return userAgent;
  if (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string') {
    return navigator.userAgent;
  }
  return '';
};

/**
 * 判斷當前環境是否為 App WebView
 * @param userAgent 可選的 User-Agent 字串，不提供時會使用 navigator.userAgent
 * @returns 是否為 WebView 環境
 */
export const isWebview = (userAgent?: string): boolean => {
  const useragent = getUserAgent(userAgent);
  if (!useragent) return false;

  const rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari/)', // iOS
    'Android.*(wv|Version/[0-9.]+.*Chrome)', // Chrome Android
    'Linux; U; Android', // 舊版 Chrome Android
  ];
  const regex = new RegExp(`(${rules.join('|')})`, 'ig');
  return Boolean(useragent.match(regex));
};
